// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-wrapper {
  display: flex;
  vertical-align: middle;
  height: 100vh;
  justify-content: center;
  align-items: center;
  position: relative;
}
.forgot-password-wrapper mat-card-header {
  text-align: center;
  width: 100%;
  display: block;
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--spacing-thin);
}
.forgot-password-wrapper mat-card-header mat-card-title {
  font-size: var(--font-size-x-large);
  margin: 0;
}
.forgot-password-wrapper .mat-card {
  padding: 2.5rem 4.4rem 3.1rem;
}
.forgot-password-wrapper .mat-stroked-button {
  line-height: 3.4rem;
  background-color: rgb(243, 242, 241);
}
.forgot-password-wrapper .mat-form-field-appearance-legacy .mat-form-field-infix {
  padding: 0.8375em 0;
}
.forgot-password-wrapper .full-width {
  width: 100%;
}
.forgot-password-wrapper .buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}
.forgot-password-wrapper .logo {
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.background-image {
  position: absolute;
  inset: 0 0 0 0;
  opacity: 0.2;
  height: 100%;
  width: 100%;
  background-image: url(/images/map.png);
  background-color: var(--background-color-dark);
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-user-select: none;
          user-select: none;
  cursor: default;
  transition: background-image var(--delay-short) var(--timing-function-default), background-color var(--delay-long) var(--timing-function-default);
}`, "",{"version":3,"sources":["webpack://./src/app/components/forgot-password/forgot-password.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,oCAAA;EACA,kCAAA;AAAR;AAEQ;EACI,mCAAA;EACA,SAAA;AAAZ;AAII;EACI,6BAAA;AAFR;AAKI;EACI,mBAAA;EACA,oCAAA;AAHR;AAMI;EACI,mBAAA;AAJR;AAOI;EACI,WAAA;AALR;AAQI;EACI,aAAA;EACA,yBAAA;EACA,SAAA;AANR;AASI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AAPR;;AAWA;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,8CAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,iJAAA;AARJ","sourcesContent":[".forgot-password-wrapper {\n    display: flex;\n    vertical-align: middle;\n    height: 100vh;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n\n    mat-card-header {\n        text-align: center;\n        width: 100%;\n        display: block;\n        font-weight: var(--font-weight-bold);\n        margin-bottom: var(--spacing-thin);\n\n        mat-card-title {\n            font-size: var(--font-size-x-large);\n            margin: 0;\n        }\n    }\n\n    .mat-card {\n        padding: 2.5rem 4.4rem 3.1rem\n    }\n\n    .mat-stroked-button {\n        line-height: 3.4rem;\n        background-color: rgb(243, 242, 241);\n    }\n\n    .mat-form-field-appearance-legacy .mat-form-field-infix {\n        padding: 0.8375em 0;\n    }\n\n    .full-width {\n        width: 100%;\n    }\n\n    .buttons{\n        display: flex;\n        justify-content: flex-end;\n        gap: 1rem;\n    }\n\n    .logo {\n        position: absolute;\n        top: 1rem;\n        left: 1rem;\n    }\n}\n\n.background-image {\n    position: absolute;\n    inset: 0 0 0 0;\n    opacity: 0.2;\n    height: 100%;\n    width: 100%;\n    background-image: url(/images/map.png);\n    background-color: var(--background-color-dark);\n    background-repeat: no-repeat;\n    background-size: cover;\n    user-select: none;\n    cursor: default;\n    transition: background-image var(--delay-short) var(--timing-function-default), background-color var(--delay-long) var(--timing-function-default);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
